export default __webpack_public_path__ + "static/media/dc-summary.de7d159b.svg";